import { useCallback, useRef } from 'react';

export const useDialog = () => {
  const ref = useRef<HTMLDialogElement>(null);

  const handleCloseDialog = useCallback(() => {
    ref.current?.close();
  }, [ref.current])

  const handleOpenDialog = useCallback(() => {
    ref.current?.showModal();
  }, [ref.current])

  return {
    ref,
    handleCloseDialog,
    handleOpenDialog,
  }
};
